import api from './api';
export default {

    post: (objectTypes) => api.post('/api/specifications', { objectTypes }),

};